'use client';

import { use } from 'react';

import { ThemeID } from '@common/types/ThemeID';

const ab = () => import('@common/styles/theme/generated/theme-ab').then((x) => x.default);
const admin = () => import('@common/styles/theme/generated/theme-admin').then((x) => x.default);
const bi = () => import('@common/styles/theme/generated/theme-bi').then((x) => x.default);
const br = () => import('@common/styles/theme/generated/theme-br').then((x) => x.default);
const mh = () => import('@common/styles/theme/generated/theme-mh').then((x) => x.default);
const rw = () => import('@common/styles/theme/generated/theme-rw').then((x) => x.default);
const vi = () => import('@common/styles/theme/generated/theme-vi').then((x) => x.default);
const vn = () => import('@common/styles/theme/generated/theme-vn').then((x) => x.default);
const vp = () => import('@common/styles/theme/generated/theme-vp').then((x) => x.default);
const vpbe = () => import('@common/styles/theme/generated/theme-vpbe').then((x) => x.default);
const wh = () => import('@common/styles/theme/generated/theme-wh').then((x) => x.default);

interface Props {
    themeID: ThemeID;
}

const THEME_CSS_LOADER_MAP: Record<ThemeID, () => Promise<string>> = {
    [ThemeID.AB]: ab,
    [ThemeID.ADMIN]: admin,
    [ThemeID.BI]: bi,
    [ThemeID.BR]: br,
    [ThemeID.MH]: mh,
    [ThemeID.RW]: rw,
    [ThemeID.VI]: vi,
    [ThemeID.VN]: vn,
    [ThemeID.VP]: vp,
    [ThemeID.VPBE]: vpbe,
    [ThemeID.WH]: wh,
};

const promises: Partial<Record<ThemeID, Promise<string>>> = {};

export const ThemeVariables = ({ themeID }: Props) => {
    if (!promises[themeID]) {
        const loader = THEME_CSS_LOADER_MAP[themeID];
        promises[themeID] = loader();
    }

    const promise = promises[themeID];
    const css = use(promise);

    return <style dangerouslySetInnerHTML={{ __html: css }} />;
};
